<template>
  <div>
    <div class="gamelist" v-if="isHome">
      <div class="btnbox" @click="addGame">
        <el-button class="add-btn" icon="el-icon-plus">添加游戏</el-button>
      </div>
      <div class="content">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="gameName" label="游戏名称"> </el-table-column>
          <el-table-column prop="unityKey" label="unityKey"> </el-table-column>
          <el-table-column prop="unityKey" label="资源">
            <template slot-scope="{ row }">
              <div class="handle-box">
                <!-- <p @click="enterInto('/music')">音乐</p>
                <p @click="enterInto('/background')">背景</p>
                <p @click="enterInto('/material')">素材</p> -->
                <el-button
                  class="textOrange-btn"
                  @click="enterInto('/video', row)"
                  >教程视频</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="unityKey" label="游戏排序号">
            <template slot-scope="{ row }">
              {{ Number(row.gameSort) }}
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="创建时间" min-width="120">
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="100">
            <template slot-scope="{ row }">
              <el-button
                class="textOrange-btn"
                @click="goEdit(row)"
                style="margin-right: 10px"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <pagination
          v-show="total > queryParams.pageSize"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="init"
        />
      </div>
    </div>
    <router-view v-else></router-view>
    <!-- 编辑游戏 -->
    <el-dialog
      :visible.sync="addVisible"
      :before-close="handleClose"
      destroy-on-close
      :show-close="false"
      width="40%"
    >
      <div slot="title" class="title">
        <p>{{ type === "add" ? "添加" : "修改" }}游戏</p>
        <span @click="handleClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-content">
        <el-form
          :model="gameForm"
          :rules="gameRules"
          ref="gameForm"
          class="demo-gameForm"
          label-position="left"
          label-width="120px"
        >
          <el-form-item label="游戏名称：" prop="gameName">
            <el-input
              v-model="gameForm.gameName"
              placeholder="请输入游戏名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="unityKey：" prop="unityKey">
            <el-input
              v-model="gameForm.unityKey"
              placeholder="请输入unityKey"
            ></el-input>
          </el-form-item>
          <el-form-item label="游戏排序号：" prop="gameSort">
            <el-input
              v-model="gameForm.gameSort"
              placeholder="请输入游戏排序号"
            ></el-input>
          </el-form-item>
          <el-form-item class="handlebox" label=" ">
            <el-button
              type="primary"
              @click="submitForm('gameForm')"
              class="enter-btn save-btn"
              :loading="submitLoading"
              >保存</el-button
            >
            <el-button
              @click="resetForm('gameForm')"
              class="cancel-btn calloff-btn"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGameList, setGame } from "@/api/unity";
export default {
  data() {
    return {
      isHome: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      gameForm: {
        gameName: "",
        unityKey: "",
        gameSort: "",
      },
      gameRules: {
        gameName: [
          { required: true, message: "请输入游戏名称", trigger: "blur" },
        ],
        unityKey: [
          { required: true, message: "请输入游戏unitykey", trigger: "blur" },
        ],
        gameSort: [
          { required: true, message: "请输入游戏", trigger: "blur" },
          {
            pattern: /^\+?[1-9]\d*$/,
            message: "请输入大于0的整数",
            trigger: "change",
          },
        ],
      },
      submitLoading: false,
      type: "add",
      addVisible: false,
    };
  },
  watch: {
    $route(route) {
      // console.log(route);
      if (route.path === "/gamelist") {
        this.isHome = true;
      } else {
        this.isHome = false;
      }
    },
  },
  created() {
    if (this.$route.path === "/gamelist") {
      this.isHome = true;
    } else {
      this.isHome = false;
    }
    this.init();
  },
  mounted() {},
  methods: {
    //获取体感游戏列表
    async init() {
      const res = await getGameList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 删除
    async deleteFn() {
      // await deleteDevice({ id });
      // this.$message.success("删除成功");
      // this.init();
    },
    enterInto(path, row) {
      this.$router.push({
        path,
        query: {
          id: row.id,
        },
      });
    },
    handleClose() {
      this.addVisible = false;
    },
    // 添加
    addGame() {
      this.type = "add";
      this.addVisible = true;
    },
    // 添加游戏
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          await setGame(this.gameForm);
          this.submitLoading = false;
          this.$message.success("添加成功！");
          this.resetForm(formName);
          this.init();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      // console.log(formName);
      this.$refs[formName].resetFields();
      this.handleClose();
    },
    // 编辑游戏
    goEdit(item) {
      this.gameForm = item;
      this.type = "edit";
      this.addVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.gamelist {
  position: relative;
  > .btnbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
}
::v-deep .demo-gameForm {
  width: 80%;
  .el-form-item {
    display: flex;
    align-items: center;
  }
  .el-form-item__label {
    white-space: nowrap;
    width: 120px !important;
    font-weight: 400;
    font-size: 14px;
    color: #262626;
  }
  .el-form-item__content {
    width: 0;
    flex: 1;
    margin: 0 !important;
  }
  .handlebox {
    // text-align: right;
    margin-top: 50px;
  }
  // .el-input {
  //   width: 380px;
  // }
}
</style>
